/**
 * Cloudhouse™ — Backstage theme module
 * @module theme
 *
 * Registers the Cloudhouse light and dark themes with the app via
 * ThemeBlueprint. Naming the extensions 'light' and 'dark' (the default
 * theme ids from @backstage/plugin-app) overrides the stock Backstage
 * themes, so the Settings > Appearance picker only shows Cloudhouse.
 */
import { UnifiedThemeProvider } from '@backstage/theme';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import DarkModeIcon from '@material-ui/icons/Brightness2';
import LightModeIcon from '@material-ui/icons/WbSunny';
import { cloudhouseDark, cloudhouseLight } from './cloudhouseTheme';

const cloudhouseDarkTheme = ThemeBlueprint.make({
  name: 'dark',
  params: {
    theme: {
      id: 'dark',
      title: 'Cloudhouse Dark',
      variant: 'dark',
      icon: <DarkModeIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={cloudhouseDark}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

const cloudhouseLightTheme = ThemeBlueprint.make({
  name: 'light',
  params: {
    theme: {
      id: 'light',
      title: 'Cloudhouse Light',
      variant: 'light',
      icon: <LightModeIcon />,
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={cloudhouseLight}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [cloudhouseDarkTheme, cloudhouseLightTheme],
});
